import { IGruppo } from './../interfaces/IGruppo';
import { finalize } from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/api';
import { GruppoService } from '../services/gruppo.service';
import { Loading } from '../utils/loading';
import { RequestBuilder } from '../classes/request-builder';
import { AlertUtil } from '../utils/alert-util';
import { TranslateService } from '@ngx-translate/core';
import { RuoloService } from '../services/ruolo.service';
import { IRuolo } from '../interfaces/IRuolo';
import { ICommessa } from '../interfaces/ICommessa';
import { CommessaService } from '../services/commessa.service';

@Component({
  selector: 'app-gruppo-modal',
  templateUrl: './gruppo-modal.component.html',
  styleUrls: ['./gruppo-modal.component.css']
})
export class GruppoModalComponent implements OnInit {

  gruppoForm: FormGroup
  gruppoForUpdate: IGruppo
  isUpdate: boolean = false
  payloadRuoli: any

  ruoli: IRuolo[]
  selectedRuolo: IRuolo

  listaCommesse: ICommessa[]
  commesseSelected: ICommessa[]

  constructor(private formBuilder: FormBuilder,
    private ref: DynamicDialogRef,
    private config: DynamicDialogConfig,
    private alertUtil: AlertUtil,
    private commessaService: CommessaService,
    public gruppoService: GruppoService,
    private ruoloService: RuoloService,
    private translate: TranslateService) {
    setTimeout(() => {
      this.getAllRuoli()
      this.getAllCommesse()
    }, 0);

    this.gruppoForUpdate = this.config.data.gruppo
    this.isUpdate = this.gruppoForUpdate ? true : false
    //build form group
    this.setForm();
  }

  private setForm() {
    this.gruppoForm = this.formBuilder.group({
      'nomeGruppo': [this.gruppoForUpdate ? this.gruppoForUpdate.Nome : '', Validators.required],
      'descrizione': [this.gruppoForUpdate ? this.gruppoForUpdate.Descrizione : ''],
      'ruolo': [this.gruppoForUpdate ? this.gruppoForUpdate.Ruolo : '', Validators.required],
      'commesseSelected': [this.gruppoForUpdate ? this.gruppoForUpdate.Commesse : []]
    });
  }

  ngOnInit() {
  }

  // convenience getter for easy access to form fields
  get form() { return this.gruppoForm.controls; }

  onSubmit() {
    if (this.gruppoForm.valid) {
      //retrieve values from form
      let nomeGruppo = this.gruppoForm.controls['nomeGruppo'].value
      let descrizione = this.gruppoForm.controls['descrizione'].value
      let ruolo = this.gruppoForm.controls['ruolo'].value

      //build aggiudicatario
      let gruppoObj: IGruppo = {
        Id: this.isUpdate ? this.gruppoForUpdate.Id : 0, //if is update set id
        Nome: nomeGruppo,
        Descrizione: descrizione,
        Ruolo: ruolo
      }

      this.saveGruppo(gruppoObj, (gruppoResponse) => {
        this.associaCommesseAlGruppo(gruppoResponse)
      })
    }
  }

  /**
   * create or update gruppo
   * @param gruppoObj gruppoObj
   */
  saveGruppo(gruppoObj: IGruppo, callback?: any) {
    Loading.isLoading = true
    let reqBuilder = new RequestBuilder(gruppoObj)
    this.gruppoService.save(reqBuilder).pipe(finalize(() => {
      Loading.isLoading = false
    })).subscribe(response => {
      if (response.data) {
        gruppoObj.Id = response.data.Id
        if (callback) {
          callback(gruppoObj)
        }
      }
      else if (response.error) {
        let errorKey = "LBL_ERROR_" + response.error.Code
        this.alertUtil.showErrorAlert(errorKey)
        console.log("ERROR: " + response.error.Stack)
      }
      else {
        this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
      }
    },
      error => {
        let errorKey = "LBL_HTTP_ERROR_0"
        if (error.status) {
          errorKey = "LBL_HTTP_ERROR_" + error.status
        }
        this.alertUtil.showErrorAlert(errorKey)
      })
  }

  /**
   * fetch all ruoli for dropdown
   */
  getAllRuoli() {
    this.setPayloadRuoli()
    Loading.isLoading = true
    let reqBuilder = new RequestBuilder(this.payloadRuoli)
    this.ruoloService.getAllRuoli(reqBuilder).pipe(finalize(() => {
      Loading.isLoading = false
    })).subscribe(
      response => {
        if (response.data) {
          this.ruoli = response.data
        }
        else if (response.error) {
          let errorKey = "LBL_ERROR_" + response.error.Code
          this.alertUtil.showErrorAlert(errorKey)
          console.log("ERROR: " + response.error.Stack)
        }
        else {
          this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
        }
      },
      error => {
        let errorKey = "LBL_HTTP_ERROR_0"
        if (error.status) {
          errorKey = "LBL_HTTP_ERROR_" + error.status
        }
        this.alertUtil.showErrorAlert(errorKey)
      })
  }

  /**
   * set payload for fetch
   */
  setPayloadRuoli() {
    this.payloadRuoli = {
      ApplicationName: "/",
      IsGruppo: true
    }
  }

  /**
  * retrieve all commesse
  */
  getAllCommesse() {
    Loading.isLoading = true
    let reqBuilder = new RequestBuilder({})
    this.commessaService.getAllCommesse(reqBuilder).pipe(finalize(() => {
      Loading.isLoading = false
    })).subscribe(
      response => {
        if (response.data) {
          this.listaCommesse = response.data
          this.prepareCommesse()
        }
        else if (response.error) {
          let errorKey = "LBL_ERROR_" + response.error.Code
          this.alertUtil.showErrorAlert(errorKey)
          console.log("ERROR: " + response.error.Stack)
        }
        else {
          this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
        }
      },
      error => {
        let errorKey = "LBL_HTTP_ERROR_0"
        if (error.status) {
          errorKey = "LBL_HTTP_ERROR_" + error.status
        }
        this.alertUtil.showErrorAlert(errorKey)
      })
  }

  prepareCommesse() {
    if (!this.listaCommesse) {
      this.listaCommesse = [];
      return;
    }
  this.listaCommesse = this.listaCommesse.map(commessa => ({
    ...commessa,
    displayLabel: `${commessa.Codice} - ${commessa.Aggiudicatario.Ragione_sociale}`
  }));
}

  associaCommesseAlGruppo(gruppoObj) {
    Loading.isLoading = true
    let commesse: any[] = []
    this.gruppoForm.controls['commesseSelected'].value.forEach(commessa => {
      commesse.push(commessa.Id)
    });
    let data = {
      "idgruppo": gruppoObj.Id,
      "commesse": commesse
    }
    let reqBuilder = new RequestBuilder(data)
    this.gruppoService.associaCommesseAlGruppo(reqBuilder).pipe(finalize(() => {
      Loading.isLoading = false
    })).subscribe(response => {
      if (response.data) {
        this.alertUtil.showAlert("LBL_NEW_GRUPPO_SUCCESS", null, null, null, () => {
          this.ref.close(true)
        })
      }
      else if (response.error) {
        let errorKey = "LBL_ERROR_" + response.error.Code
        this.alertUtil.showErrorAlert(errorKey)
        console.log("ERROR: " + response.error.Stack)
      }
      else {
        this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
      }
    },
      error => {
        let errorKey = "LBL_HTTP_ERROR_0"
        if (error.status) {
          errorKey = "LBL_HTTP_ERROR_" + error.status
        }
        this.alertUtil.showErrorAlert(errorKey)
      })
  }
}
